import request from '@/config/request'

export default {

  searchLastConsumeDate: function (customerCode, status) {
    return request({
      url: '/order/consumeorder/searchlastconsumedate',
      method: 'get',
      params: {
        customercode: customerCode,
        status: status
      }
    })
  },

  searchConsumeOrder: function (orderCode ,customerCode, status) {
    return request({
      url: '/order/consumeorder/searchconsumeorder',
      method: 'get',
      params: {
        ordercode : orderCode,
        customercode: customerCode,
        status: status
      }
    })
  },

  searchListConsumeOrder: function (customerCode, status) {
    return request({
      url: '/order/consumeorder/searchlistconsumeorder',
      method: 'get',
      params: {
        customercode: customerCode,
        status: status
      }
    })
  },
  searchConsumeOrderCount: function (customerCode, status) {
    return request({
      url: '/order/consumeorder/searchconsumeordercount',
      method: 'get',
      params: {
        customercode: customerCode,
        status: status
      }
    })
  },
  searchConsumeOrderByPage: function (customerCode, status,pageNum ,pageSize) {
    return request({
      url: '/order/consumeorder/searchconsumeorderbypage',
      method: 'get',
      params: {
        customercode: customerCode,
        status: status,
        pagenum: pageNum,
        pagesize : pageSize,
      }
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/order/consumeorder.js